/** @file Gizmo frame of a transform tool: on the last bone; scale follows its world X, others world axes. */
import { POSE_LAYOUT } from '@pose2d/core/contracts/pose';
import type { GizmoFrame, GizmoTool } from '@pose2d/editor-geometry/types';
import { angle } from '@pose2d/math/angle';
import { trig } from '@pose2d/math/trig';
import type { ToolContext } from '../../panels/viewport/viewportTypes';
import { boneOrigin } from './boneOrigin';

/** `bones` is topSelected's result (non-empty). */
export function gizmoFrame(ctx: Pick<ToolContext, 'pose' | 'camera'>, bones: readonly number[], tool: GizmoTool): GizmoFrame {
  const i = bones.at(-1) ?? 0;
  const base = i * POSE_LAYOUT.WORLD_STRIDE;
  const w = ctx.pose.world;
  const rotation = tool === 'scale' ? angle.radToDeg(trig.atan2(w[base + 2] ?? 0, w[base] ?? 1)) : 0;
  return { camera: ctx.camera, origin: boneOrigin(ctx.pose, i), rotation };
}
